module.exports = __webpack_public_path__ + "d580de422588527ea5af86d7136de410.png";